<template>
  <div
      class="wrapper"
      :class="[
      { 'overflow-x-hidden': modalIsOpen, 'wrapper--messenger': router_name === 'messenger' },
    ]"
  >
    <notifications></notifications>
    <div class="content-shell" :class="{ 'content-shell--messenger': router_name === 'messenger' }">
      <sidebar-content-column :tab="sidebarTab"/>
      <div class="main-panel" :class="{ 'has-top-navbar': router_name === 'messenger' }">
        <template v-if="router_name === 'messenger'">
          <top-navbar></top-navbar>
        </template>
        <div
          :class="{
            content: router_name !== 'Group' && router_name !== 'profile',
            'group-detail__container': router_name === 'Group' || router_name === 'profile',
          }"
        >
          <zoom-center-transition :duration="200" mode="out-in">
            <!-- your content here -->
            <router-view/>
          </zoom-center-transition>
        </div>
      </div>
      <div
        v-if="router_name === 'messenger'"
        id="messenger-right-column"
        class="messenger-right-column"
        :class="{ 'messenger-right-column--hidden': !isMessengerRightBarVisible }"
      ></div>
    </div>
    <!-- Popover ở đây (ngoài content-shell) để không bị main-panel đè: sidebar-wrapper chỉ có z-index: 4 -->
    <popover
      ref="messengerCreateMessagePopover"
      name="messenger-create-message"
      class="text-400-medium popover-create-message"
      :width="220"
    >
      <div
        class="createChat create-messagePrivate cursor-pointer p-10px"
        @click="openMessengerMemberListModal"
      >
        <span>Tạo tin nhắn riêng</span>
      </div>
      <div
        class="createChat createGroupChat cursor-pointer p-10px"
        @click="openMessengerAddUserModal"
      >
        <span>Tạo nhóm chat</span>
      </div>
      <div
        class="createChat createGroupChat cursor-pointer p-10px"
        @click="openMessengerRequestJoinModal"
      >
        <span>Yêu cầu vào nhóm chat</span>
      </div>
    </popover>
    <create-group-modal></create-group-modal>
    <create-post-modal></create-post-modal>
    <core-value-modal></core-value-modal>
    <branch-detail-modal></branch-detail-modal>
    <v-dialog/>
    <create-category-modal></create-category-modal>
    <user-post-interactive-modal></user-post-interactive-modal>
    <user-message-interactive-modal></user-message-interactive-modal>
    <tooltip />
    <show-comment-image />
    <slide-show-modal />
    <add-user-modal></add-user-modal>
    <member-list-modal></member-list-modal>
    <update-company-structure-modal />
    <reaction-message-detail-modal />
    <notification-setting-modal @toggle-notification="toggleNotification"/>
    <add-group-member-modal />
    <request-join-chat-group-modal />
    <ListMessageHistoryModal />
    <create-chat-bot-message-modal />
    <post-detail-modal />
    <chat-join-requests-modal @count-updated="onChatJoinRequestsCountUpdated" />
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import TopNavbar from "./TopNavbar.vue";
import SidebarContentColumn from "../Components/SidebarPlugin/SidebarContentColumn.vue";
import CreateGroupModal from "../Components/Modal/CreateGroupModal";
import CreatePostModal from "../Components/Modal/CreatePostModal";
import CoreValueModal from "../Components/Modal/CoreValueModal";
import BranchDetailModal from "../Components/Modal/BranchDetailModal";
import CreateCategoryModal from "../Components/Modal/CreateCategoryModal";
import UserPostInteractiveModal from "../Components/Modal/UserPostInteractive";
import ShowCommentImage from "../Components/Modal/ShowCommentImage";
import AddUserModal from "../Components/Modal/AddUserModal";
import UpdateCompanyStructureModal from "../Components/Modal/UpdateCompanyStructureModal";
import MemberListModal from "../Components/Modal/MemberListModal";
import SlideShowModal from "../Components/Modal/SlideShowModal";
import UserMessageInteractiveModal from "../Components/Modal/UserMessageInteractive.vue";
import NotificationSettingModal from "../Components/Modal/NotificationSettingModal";
import ReactionMessageDetailModal from "../Components/Modal/ReactionMessageDetailModal";
import GroupMemberListModal from "../Components/Modal/AdminManagement/GroupMemberListModal";
import AddGroupMemberModal from "../Components/Modal/AddGroupMemberModal";
import RequestJoinChatGroupModal from "../Components/Modal/RequestJoinChatGroupModal";
import ListMessageHistoryModal from "../Components/Modal/ListMessageHistoryModal";
import CreateChatBotMessageModal from "../Components/Modal/AdminManagement/CreateChatBotMessageModal";
import PostDetailModal from "../Components/Modal/PostDetailModal";
import ChatJoinRequestsModal from "../Components/Modal/ChatJoinRequestsModal.vue";
import { TYPE_ADD_GROUP_MEMBER } from "../../const/const";
import { isMessengerRightColumnLayoutVisible } from "../../helper/messengerViewport";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar-wrapper");
    // initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

// import ContentFooter from "./ContentFooter.vue";
// import MobileMenu from "./Extra/MobileMenu.vue";
// import UserMenu from "./Extra/UserMenu.vue";

export default {
  components: {
    PostDetailModal,
    AddUserModal,
    UserPostInteractiveModal,
    CreateCategoryModal,
    BranchDetailModal,
    CreatePostModal,
    TopNavbar,
    SidebarContentColumn,
    CreateGroupModal,
    CoreValueModal,
    ShowCommentImage,
    UpdateCompanyStructureModal,
    MemberListModal,
    SlideShowModal,
    UserMessageInteractiveModal,
    NotificationSettingModal,
    ReactionMessageDetailModal,
    AddGroupMemberModal,
    RequestJoinChatGroupModal,
    ListMessageHistoryModal,
    CreateChatBotMessageModal,
    ChatJoinRequestsModal
    // ContentFooter,
    // FixedPlugin,
    // MobileMenu,
    // UserMenu,
  },
  data() {
    return {
      router_name: this.$route.name,
      sidebarTab: this.$route.meta.tab || "workplace",
      modalIsOpen: this.$store.state.modalIsOpen,
      messengerViewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1920,
      messengerViewportResizeHandler: null,
    };
  },
  computed: {
    isMessengerRightBarVisible() {
      return isMessengerRightColumnLayoutVisible(
        this.$store.state.chat?.chatGroupSelected,
        this.messengerViewportWidth,
      );
    },
  },
  methods: {
    onChatJoinRequestsCountUpdated(count) {
      this.$root.$emit('chat-join-requests-count-updated', count);
    },
    logout() {
      this.$store.dispatch("auth/logout");
    },
    toggleNotification(e) {
      if (e.postId) {
        let posts = this.$store.state.post.posts;
        for (let i = 0; i < posts.length; i++) {
          if (posts[i].post.id === e.postId) {
            posts[i].post.enable_notification = e.enableNotification;
            break;
          }
        };
        this.$store.commit("updatePost", posts);
      }
    },
    closeMessengerCreateMessagePopover() {
      const p = this.$refs.messengerCreateMessagePopover;
      if (p && typeof p.hideEventListener === "function") {
        p.hideEventListener({});
      }
    },
    openMessengerMemberListModal() {
      this.closeMessengerCreateMessagePopover();
      this.$modal.show("member-list-modal");
    },
    openMessengerAddUserModal() {
      this.closeMessengerCreateMessagePopover();
      this.$modal.show("add-user-modal", {
        type: TYPE_ADD_GROUP_MEMBER.CREATE_GROUP,
      });
    },
    openMessengerRequestJoinModal() {
      this.closeMessengerCreateMessagePopover();
      this.$modal.show("request-join-chat-group-modal");
    },
    syncMessengerViewportWidth() {
      if (typeof window === 'undefined') {
        return;
      }
      this.messengerViewportWidth = window.innerWidth;
    },
    checkIsHasUser(){
      const store = this.$store.state.auth.user;
      if(!store.id){
        this.$store.dispatch("alerts/error", 'Hết phiên đăng nhập, tự động chuyển đến trang đăng nhập!');
        setTimeout(() => {
          window.app.$store.dispatch("redirectToLogin");
        }, 1500);
      }
    }
  },
  updated() {
    this.checkIsHasUser();
    reinitScrollbar();
  },
  mounted() {
    this.checkIsHasUser();
    reinitScrollbar();
    this.syncMessengerViewportWidth();
    this.messengerViewportResizeHandler = () => {
      this.syncMessengerViewportWidth();
    };
    window.addEventListener('resize', this.messengerViewportResizeHandler, { passive: true });
  },
  beforeDestroy() {
    if (this.messengerViewportResizeHandler) {
      window.removeEventListener('resize', this.messengerViewportResizeHandler);
    }
  },
  watch: {
    '$route'(to, from) {
      this.router_name = to.name
      this.sidebarTab = to.meta.tab || 'workplace'
    },
    '$store.state.auth.modalIsOpen': function (newVal, oldVal) {
      this.modalIsOpen = newVal
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

.overflow-x-hidden{
  overflow-x: visible;
}

.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.main-panel {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.main-panel > .content,
.main-panel > .group-detail__container {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}


@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}

.content-shell {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  width: auto;
  margin-left: 0;
  overflow: hidden;
}

.content-shell--messenger {
  display: flex;
  margin-left: 0;
  width: auto;
  min-width: 0;
  height: 100%;
  overflow: hidden;
}

.content-shell > .sidebar-wrapper {
  position: relative;
  flex: 0 0 300px;
  width: 300px;
  height: 100%;
  min-height: 0;
  overflow: auto;
  z-index: 4;
  background: #fff;
  border-right: 1px solid #e4e4e4;
}

.content-shell > .sidebar-wrapper .md-list {
  background-color: transparent !important;
}

.content-shell > .sidebar-wrapper .md-list .md-list-item a {
  text-transform: capitalize;
}

.content-shell > .sidebar-wrapper .md-list .md-list-item-content {
  justify-content: flex-start;
  min-height: auto;
}

.content-shell > .sidebar-wrapper .md-list .md-list-item-container:hover {
  background-color: rgba(200, 200, 200, 0.2) !important;
}

.content-shell > .sidebar-wrapper .md-ripple span .md-ripple-wave {
  background-color: rgba(200, 200, 200, 0.4) !important;
}

.content-shell > .sidebar-wrapper > .nav {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  margin-top: 0;
  padding: 0;
}

.content-shell > .sidebar-wrapper .social-bar,
.content-shell > .sidebar-wrapper .notification-bar {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  overflow: visible;
}

.content-shell > .sidebar-wrapper .content-sidebar {
  padding: 0 15px !important;
}

.content-shell > .sidebar-wrapper .notification-bar .content-sidebar {
  padding: 0 !important;
}

.content-shell > .sidebar-wrapper .notification-bar .md-list-item-content {
  padding: 8px 6px !important;
}

.content-shell--messenger .main-panel {
  flex: 1 1 auto;
  min-width: 0;
  width: auto;
  float: none;
}

.content-shell--messenger .main-panel.has-top-navbar {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.content-shell--messenger .main-panel.has-top-navbar > .content {
  flex: 1 1 auto;
  min-height: 0;
  height: auto;
  overflow: hidden;
}

.messenger-right-column {
  flex: 0 0 360px;
  width: 360px;
  min-width: 360px;
  height: 100%;
  border-left: 1px solid #e7e7e7;
  background: #fff;
  overflow: hidden;
}

.messenger-right-column--hidden {
  display: none;
}

.messenger-right-column .sidebar-infomation,
.messenger-right-column .messenger-sidebar-panel {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.wrapper.wrapper--messenger {
  overflow: hidden;
}

/* Popover “Soạn tin” mount ngoài content-shell; z-index !important vì plugin gán inline thấp hơn panel */
.popover-create-message.vue-popover {
  min-width: 200px;
  z-index: 10050 !important;
  top: 64px !important;
}

/* Ẩn nút hamburger sidebar trên topbar chat (mọi breakpoint, kể cả mobile) */
.content-shell--messenger .md-toolbar-section-end .md-toolbar-toggle {
  display: none !important;
}

.content-shell--messenger,
.content-shell--messenger .main-panel,
.content-shell--messenger .main-panel .content {
  overflow-x: hidden !important;
}

//.main-panel {
//  overflow: visible !important;
//}
</style>
